import markLight from '../../assets/insanex-mark-light.svg';
import markDark from '../../assets/insanex-mark-dark.svg';
import { useTheme } from '../../app/ThemeProvider';
import { COMPANY_NAME } from '../../app/appInfo';

/**
 * The iNsaneX Tech "X" mark — the company's own brand, distinct from the
 * {@link LiftXLogo} product wordmark. Transparent background by design: it
 * sits directly on whatever surface it is placed on (a card, the page body)
 * rather than carrying its own boxed background, so light/dark surfaces
 * both render it correctly with no visible edge.
 *
 * Per `appInfo.ts`'s own rule, "iNsaneX Tech" appears only in About,
 * Settings, and legal/metadata contexts — never in the workout UI. This
 * component is a small credit mark for exactly those contexts, not a
 * general-purpose logo to place anywhere.
 */
export function CompanyMark({
  size = 18,
  className,
}: {
  size?: number;
  className?: string | undefined;
}): React.JSX.Element {
  const { resolved } = useTheme();

  return (
    <img
      src={resolved === 'dark' ? markDark : markLight}
      alt={COMPANY_NAME}
      className={className}
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        display: 'inline-block',
        flexShrink: 0,
        verticalAlign: 'middle',
      }}
      draggable={false}
    />
  );
}
